import React from "react";
import PropTypes from "prop-types";

import Loader from "../Loader/index";
import theme from "../../design/theme";
import useMyProfile from "../../hooks/account/use-my-profile";
import BannerHeaderSection from "./components/BannerHeaderSection";
import SideNavigation from "./components/SideNavigation";
import { Container, Banner, LoaderContainer } from "./styles";

function AccountLayout({ render, ...rest }) {
  const { loading, profile } = useMyProfile();
  return (
    <Container>
      <SideNavigation />
      <Banner startColor={theme.primary.base} endColor={theme.secondary.base}>
        <BannerHeaderSection profile={profile} />
      </Banner>
      {loading ? (
        <LoaderContainer>
          <Loader fullScreen={false} />
        </LoaderContainer>
      ) : (
        render({ profile, ...rest })
      )}
    </Container>
  );
}

AccountLayout.propTypes = {
  render: PropTypes.func,
};

export default AccountLayout;
